import React, { useEffect } from 'react';
import useApi from '../../hook/useApi';
import { useState } from 'react';
import { toast } from 'react-toastify';
import Loader from '../Loader/Loader';
import { useAuth } from '../../context/AuthContext';

const IcoCardLayer = () => {
     const { AsyncGetApiCall } = useApi();
     const [data, setData] = useState(null);
     const [loading, setLoading] = useState(false);
     const { icoValues } = useAuth()

     const getAirdropStats = async () => {
          try {
               setLoading(true)
               const result = await AsyncGetApiCall("/private-sale/get-stats");
               console.log("result of getAirdropStats: ", result);
               if (result?.success) {
                    setData(result?.data);
               }
               else {
                    toast.error(result?.errors?.[0]);
               }
               console.log("result : ", result);
          } catch (error) {
               console.log("error : ", error);
          } finally {
               setLoading(false)
          }
     }

     useEffect(() => {
          getAirdropStats();
     }, []);

     return (
          <>
               {loading && <Loader />}
               <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px', paddingLeft: '0', paddingRight: '0', }}>

                    <div className='airdrop-card'>
                         <h6 className="text-xl">Total Token Hardcap</h6>
                         <span className='fw-semibold text-lg'>{Number(data?.totalQuantity).toFixed(2) || "0"}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Sold Out</h6>
                         <span className="fw-semibold text-lg">{`${Number(icoValues?.soldOut).toFixed(2)} Soli` || "0"}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Token Price</h6>
                         <span className="fw-semibold text-lg">{icoValues?.usdtValue || "0"}</span>
                    </div>
                    <div className='airdrop-card'>
                         <h6 className='text-xl'>Unique Wallets</h6>
                         <span className="fw-semibold text-lg">{data?.uniqueBuyerCount || "0"}</span>
                    </div>
               </div>
          </>
     );
};

export default IcoCardLayer;